module.exports = __webpack_public_path__ + "img/InstagramSans-Medium.929346b4.svg";